import { Component } from '@angular/core';

import { AppSettings } from '~/core/models/appsettings';

@Component({
    selector: 'notfound',
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.scss'],
    standalone: false
})

export class NotFoundComponent {
    public appSettings: AppSettings = new AppSettings();
}
